import React from 'react';
import { Lawyer } from '../../enterprise/enterprise.types';
import { EntityWithDecisionsToShow } from '../../entity/entity.types';
import { EntityModalLoader } from '../../components/entity-modal-placeholder/EntityModalLoader';
import { fetchEntrepriseLawyers } from '../../enterprise/enterprise.api';
import {
  ModalScrollableHeader,
  ModalScrollableContent,
  ModalScrollableContainer,
} from '../../components/modal';
import { LawyerListWithDecisions } from '../../entity/entity-lists/LawyerListWithDecisions';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { EntityDecisionListModalWithGoBack } from './EntityDecisionListModalWithGoBack';

type Props = {
  wording: string;
  siren: string;
  source: string;
  raisonSociale: string;
  onRequestClose: () => void;
  isOpen: boolean;
};

type State = {
  allLawyers: Array<Lawyer>;
  isLoading: boolean;
  entityWithDecisionsToShowInfos: EntityWithDecisionsToShow | null;
};

export class AllLawyersModal extends React.Component<Props, State> {
  static defaultProps = {
    onRequestClose: () => {},
    isOpen: false,
  };

  state: State = {
    allLawyers: [],
    isLoading: true,
    entityWithDecisionsToShowInfos: null,
  };

  async componentDidMount() {
    const { lawyers: allLawyers } = (
      await fetchEntrepriseLawyers(this.props.siren, true)
    ).data;
    this.setState({ allLawyers, isLoading: false });
  }

  handleClickDecision = (lawyer: Lawyer) => {
    this.setState({
      entityWithDecisionsToShowInfos: {
        name: lawyer.nom,
        params: {
          lawyerId: lawyer.lawyerId,
          siren: this.props.siren,
        },
      },
    });
    doctrineAnalytics('Entity SeeEntityDecisions', {
      source: `${this.props.source}_modal`,
    });
  };

  handleGoBack = () => {
    this.setState({ entityWithDecisionsToShowInfos: null });
  };

  render() {
    const {
      raisonSociale,
      onRequestClose,
      isOpen,
      source,
      wording,
    } = this.props;
    const {
      isLoading,
      allLawyers,
      entityWithDecisionsToShowInfos,
    } = this.state;

    return (
      <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
        {entityWithDecisionsToShowInfos ? (
          <EntityDecisionListModalWithGoBack
            entityWithDecisionsToShowInfos={entityWithDecisionsToShowInfos}
            wording={wording}
            closeModal={onRequestClose}
            handleGoBack={this.handleGoBack}
            source={source}
          />
        ) : (
          <>
            <ModalScrollableHeader
              title={`Avocats ayant représenté ${raisonSociale}`}
              onClose={onRequestClose}
            />
            <ModalScrollableContent>
              <EntityModalLoader isLoading={isLoading}>
                <LawyerListWithDecisions
                  lawyers={allLawyers}
                  source={`${source}_modal_list`}
                  wording={wording}
                  handleClickDecision={this.handleClickDecision}
                  fromModal
                />
              </EntityModalLoader>
            </ModalScrollableContent>
          </>
        )}
      </ModalScrollableContainer>
    );
  }
}
